import script from "./ONovaAtividade.vue?vue&type=script&lang=ts&setup=true"
export * from "./ONovaAtividade.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__